import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'
import ReactGA from 'react-ga';
import { Path, PathGenerator, ExternalPath } from "../../constants/path";
import { settings } from "../../assets/settings";
import { Link, Button } from "../util/Clickable";
import { Image } from "../util/Image";
import Plan from "./Plan";

import { getPlans } from "../../actions/facility";

ReactGA.initialize('UA-142451086-2');
ReactGA.pageview(window.location.pathname + window.location.search);

declare var UIkit;

class FacilityCard extends Component {

  state = {
    plans: null
  }

  componentDidMount = () => {

    const query = qs.parse(this.props.location.search.replace("?", ""));

    if (this.props.noLoad) {
      return;
    }

    this.props.actions.getPlans(this.props.facility.member_id, query).then(({ value }) => {
      if (value.data) {
        var plans = value.data.filter((plan) => {
          return plan.Plan.indexOf(settings.recomend_key) != -1;
        });

        plans = plans.filter((a) => {
          return !a.error;
        }).sort((a, b) => {
          if (+a.Price > +b.Price) {
            return 1;
          } else {
            return -1;
          }
        });

        if (plans.length > 0) {
          this.setState({
            plans: [plans[0]]
          });
        } else {
          this.setState({
            plans: []
          });
        }
      }
    }).catch(error => {
      this.setState({
        plans: []
      });
    });
  }

  getFacilityUrl = () => {
    return PathGenerator.facility(this.props.facility.id) + this.props.location.search;
  }

  render = () => {
    const facility = this.props.facility;
    return (
      <div className="uk-facility-card uk-box-shadow-small">
        <div className="uk-facility-title">
          <Link className="uk-link-reset" to={this.getFacilityUrl()}>
            <h3 className="uk-margin-remove">
              {facility.name}
            </h3>
          </Link>
        </div>
        <div className="uk-padding-small">
          <div data-uk-grid className="uk-grid-small uk-margin-small">
            <div className="uk-width-auto">
              <Link className="uk-link-reset" to={this.getFacilityUrl()}>
                <div className="uk-facility-image uk-image-wrapper">
                  <Image src={facility.image_url_m} alt={facility.name} />
                </div>
              </Link>
            </div>
            <div className="uk-width-expand">
              <div data-uk-grid className="uk-grid-small uk-flex-bottom">
                <div className="uk-width-expand">
                  <dl className="uk-description-list">
                    <dt>所在地</dt>
                    <dd>
                      <Link to={this.getFacilityUrl() + "#map"}>
                        {facility.address}
                      </Link>
                    </dd>
                    <dt>アクセス</dt>
                    <dd>
                      {facility.access}
                    </dd>
                    <dt>TEL</dt>
                    <dd>
                      <a href={"tel:" + facility.tel}>
                        {facility.tel}
                      </a>
                    </dd>
                    <dt>公式サイト</dt>
                    <dd>
                      <ReactGA.OutboundLink eventLabel={"一覧 > " + facility.name + " 公式  > " + facility.home_url} to={facility.home_url} target="_blank">
                      {facility.home_url}
                      </ReactGA.OutboundLink>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div className="uk-width-auto@s uk-width-1-1 uk-text-right">
            <Link to={this.getFacilityUrl()} className="uk-button uk-button-secondary uk-button-small">
              詳細を見る
                  </Link>
          </div>

          {
            !this.props.noLoad && (
              <hr />
            )
          }
          {
            !this.props.noLoad && (
              <div className="uk-margin-small">
                <h4>おすすめのプラン</h4>
                {(() => {
                  if (this.state.plans == null) {
                    return (
                      <div>
                        <div className="uk-text-center uk-margin-small">
                          <span {...{ 'uk-spinner': "ratio:2;" }}></span>
                        </div>
                        <div className="uk-text-center uk-margin-small">
                          <span>プランを検索中です...</span>
                        </div>
                      </div>
                    );
                  }
                })()}
                {(() => {
                  if (this.state.plans == null) {
                  } else if (this.state.plans.length == 0) {
                    return (
                      <div>
                        <div className="uk-text-center@s">
                          <span>
                            条件に該当するプランがありません。
                            {
                              facility.home_url && (
                                <span>(<a target="_blank" href={facility.home_url}>公式サイトで他のプランを見る</a>)</span>
                              )
                            }
                          </span>
                        </div>
                      </div>
                    );
                  } else {
                    return this.state.plans.map((plan, index) => {
                      return (
                        <div key={index}>
                          <Plan plan={plan} />
                        </div>
                      );
                    });
                  }
                })()}
                {this.state.plans != null && this.state.plans.length > 0 && (
                  <div className="uk-text-center">
                    <Link to={this.getFacilityUrl() + "#plans"} className="uk-button uk-button-secondary uk-button-small uk-width-medium@s">
                      おすすめのプランをもっと見る
                    </Link>
                  </div>
                )}
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getPlans: (...data) => dispatch(getPlans(...data))
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilityCard))
